import React from "react";
import Nurses from "../../../places/pages/Nurses/Nurses";
import AppLayoutAssistant from "../../../navigation/Layout/LayoutAssistant";

export default function AssistantNursesPage() {
  return <Nurses LayoutComponent={AppLayoutAssistant} />;
}
